export class FTableURLS {

    FTTABLE: string; // Page sizes available
    GET: string;  // current page size index
    PUT: string; 
    DELETE: string; 

  }
  